import React from 'react';
import { useCubeQuery } from '@/components/display/use-cube-query';
import { useLineItemContext } from '@/features/line-items/line-items-context';
import type { KpiViewMode } from './line-item-daily-kpis';
import { PacingDailyKpis } from './pacing-daily-kpis';

type Props = {
  setViewMode: (mode: KpiViewMode) => void;
};

export function PacingSpendKpis({ setViewMode }: Props) {
  const { lineItem } = useLineItemContext();

  const result = useCubeQuery({
    dimensions: ['line_items.unit_price_type_name', 'line_item_metrics_daily.line_item_id'],
    measures: [
      'line_item_metrics_daily.actual_spend_yesterday',
      'line_item_metrics_daily.planned_spend_yesterday',
      'line_item_metrics_daily.avg_actual_spend_last_3_days',
      'line_item_metrics_daily.avg_actual_spend_last_7_days'
    ],
    filters: [
      {
        member: 'line_item_metrics_daily.line_item_id',
        operator: 'equals',
        values: [lineItem.id]
      }
    ]
  });

  if (result.status === 'loading') {
    return (
      <PacingDailyKpis
        viewMode="spend"
        setViewMode={setViewMode}
        loading
        unitAbbr=""
        yesterday={{ formatted: DASH, actual: null, planned: null }}
        avg3Day={DASH}
        avg7Day={DASH}
      />
    );
  }

  if (result.status === 'error' || !result.formattedRows[0]) {
    return (
      <PacingDailyKpis
        viewMode="spend"
        setViewMode={setViewMode}
        unitAbbr=""
        yesterday={{ formatted: DASH, actual: null, planned: null }}
        avg3Day={DASH}
        avg7Day={DASH}
      />
    );
  }

  const formatted = result.formattedRows[0];

  return (
    <PacingDailyKpis
      viewMode="spend"
      setViewMode={setViewMode}
      unitAbbr=""
      yesterday={{
        formatted: formatted['line_item_metrics_daily.actual_spend_yesterday'],
        actual: null,
        planned: null
      }}
      avg3Day={formatted['line_item_metrics_daily.avg_actual_spend_last_3_days']}
      avg7Day={formatted['line_item_metrics_daily.avg_actual_spend_last_7_days']}
    />
  );
}

const DASH = '—';
